import { Card,Row,Col, Container } from "react-bootstrap";
import {HiOutlineDevicePhoneMobile} from 'react-icons/hi2';
import {FiMail} from 'react-icons/fi';
import './Style/ContactUs.css'
function ContactUs(){
    return(
        <Container fluid className="pt-5 pb-5" style={{backgroundColor:"#292930"}}>
            <Row className="justify-content-center gap-3">
                <Col md="6"  lg="4">
                <Card className="border-1 rounded-4 p-2 contactUs" style={{backgroundColor:"rgb(58, 58, 66)",color:"white",minWidth:"280px",borderColor:"gold"}}>
            <Card.Body className="d-flex align-items-center gap-3">
            <div className="fs-1 cIcon"><HiOutlineDevicePhoneMobile style={{color:"gold"}}/></div>
            <div>
                <span className="fs-3 fw-bold">رقم خدمة العملاء</span>
                <p className="fs-4">011-510-7120</p>
            </div>
            </Card.Body>
            </Card>
                </Col>
                <Col md="6"  lg="5">
                <Card className="border-1 rounded-4 p-2 contactUs" style={{backgroundColor:"rgb(58, 58, 66)",color:"white",minWidth:"260px",borderColor:"gold"}}>
            <Card.Body className="d-flex align-items-center gap-3">
            <div className="fs-1 cIcon"><FiMail style={{color:"gold"}}/></div>
            <div>
                <span className="fs-3 fw-bold">البريد الالكتروني</span>
                <p className="fs-4">customer@framelancer.io</p>
            </div>
            </Card.Body>
            </Card>
                </Col>
            </Row>
        </Container>
    )
}

export default ContactUs;